/* eslint-disable no-nested-ternary */
import CustomRefreshButton from 'Components/common/components/CustomRefreshButton';
import {
  maxMobile, maxTablet, smMobile,
} from 'Utils/utilsStyle';
import styled from 'styled-components';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCompanyProfile,
  selectProfileLoading,
  selectRefreshCompanyIds, selectSWOTData, selectSWOTLoading,
} from 'Selector/CompaniesSelector';
import React, { useState } from 'react';
import { Spin } from 'antd';
import { useSearchParams } from 'react-router-dom';
import {
  IsMobile, getCurrentTime, valueToObject,
} from 'Utils/UtilityFunctions';
import { actions as companiesActions } from 'Slice/CompaniesSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { COMPANY_SWOT_ROUTE, SWOT_ANALYSIS, TOOLTIP_SWOT } from 'Utils/Constants';
import UpdatedPill from './UpdatedPill';
import SwotPillDesk from './SwotPillDesk';
import ViewSwitcher from './ViewSwitcher';
import { selectClusterRefreshCompanyIds, selectClusterSWOTData, selectClusterSWOTLoading } from '../../../Selector/ClustersSelector';
import { actions as clusterActions } from '../../../Slice/ClustersSlice';
import classNames from 'classnames';
const Wrapper = styled.div`
  .swot-head-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 21px;
    .first-row {
       @media all and (max-width: ${maxMobile}) {
        width: 100%;
        display: flex;
        justify-content: flex-start;
      }
    }
    .left-side-div-swot {
      .responsive-update-switch {
        display: flex;
        align-items: center;
        @media all and (max-width: ${maxMobile}) {
          margin-top: 10px;
        }
      }
      .company-name {
        color: #424B50;
        font-family: "Roboto Slab";
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: -0.65px;
      }
      .heading {
        @media all and (max-width: ${maxMobile}) {
          align-items: center;
          display: flex;
          margin-left: 0px;
        }
      }
    }
    .right-side-div-swot {
      display: flex;
      align-items: center;
      @media all and (max-width: ${maxMobile}) {
        align-self: flex-start;
      }
      .head-trigger {
        display: flex;
        align-items: center;
         margin-right: 15px;
        @media all and (max-width: ${maxTablet}) {
          margin-right: 10px;
        }
        @media all and (max-width: ${smMobile}) {
          margin-right: 5px;
        }
      }
      .custom-refresh-button {
        margin-right: 15px;
        display: flex;
        @media all and (max-width: ${maxTablet}) {
          margin-right: 10px;
        }
        @media all and (max-width: ${smMobile}) {
          margin-right: 5px;
        }
      }
      .disable {
        opacity: 0.6;
        pointer-events:none;
      }
    }
  }
  .swot-tab-area {
    &.clusterLoader {
      min-height: 235px;
      .spinner {
        width: 100%;
        min-height: inherit;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
`;

type Props = {
  isSwotTab: boolean;
  isCluster?: boolean;
  clusterCompanyId?: number;
  clusterCompanyName?: string;
};

const defaultProps = {
  isCluster: false,
  clusterCompanyId: 0,
  clusterCompanyName: '',
}

const SwotAnalysis = function SwotAnalysis(props: Props) {
  const { isSwotTab, isCluster, clusterCompanyId, clusterCompanyName } = props;
  const clusterSwotLoading = useSelector(selectClusterSWOTLoading);
  const swotLoading = isCluster ? clusterSwotLoading[clusterCompanyId ?? 0] : useSelector(selectSWOTLoading);
  const companyProfileLoading = useSelector(selectProfileLoading);
  const clusterSwotData = useSelector(selectClusterSWOTData);
  const swotData = isCluster ? clusterSwotData[clusterCompanyId ?? 0] : useSelector(selectSWOTData);
  const [viewAll, setViewAll] = useState(false);
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;

  const dispatch = useDispatch();
  // const xsmMob = IsMobileXsm();
  const isMob = IsMobile();
  const refreshCompanyIds = isCluster ? useSelector(selectClusterRefreshCompanyIds) : useSelector(selectRefreshCompanyIds);
  const companyProfile = useSelector(selectCompanyProfile);
  const refreshSpecficCompany: boolean = isCluster ? refreshCompanyIds.includes(clusterCompanyId ?? 0) : refreshCompanyIds.includes(companyIdParsed);

  const { swotAnalysis, createdAt } = swotData || {};
  const [params] = useSearchParams();
  const fromNewsTab = params.get('fromNewsTab');

  const handleRefresh = () => {
    if (isCluster) {
      const startTime = getCurrentTime();
      const data = { companyId: clusterCompanyId ?? 0 };
      const message = `SWOT analysis of ${clusterCompanyName as string} is being updated, it might take 3 to 4 minutes.`;
      dispatch(flurryActions.setNotification({
        message,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
        companyId: companyIdParsed,
      }));
      dispatch(clusterActions.refreshClusterSWOTAnalysis(data));
    } else {

      const startTime = getCurrentTime();
      const data = {
        companyId: companyIdParsed,
      };
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('company_swot_refresh', startTime, { ...data }),
      ));
      const message = `SWOT analysis of ${companyProfile?.companyName as string} is being updated, it might take 3 to 4 minutes.`;
      dispatch(flurryActions.setNotification({
        message,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
        companyId: companyIdParsed,
      }));
      dispatch(companiesActions.refreshSWOTAnalysis(data));
    }
  };

  const toggleSwotView = () => {
    setViewAll(!viewAll);
  };

  console.log("swotData:", swotData);
  return (
    <Wrapper>
      <div className="heading-inner-page">
        <div className="swot-head-row">
          <div className="d-flex align-items-center first-row">
            <div className="left-side-div-swot">
              {
                isCluster && !swotLoading ? (
                  <h1 className="d-flex align-items-center company-name">
                    {clusterCompanyName}
                  </h1>
                ) : (!isCluster && !swotLoading) && (
                  <h1 className="d-flex align-items-center heading">
                    {SWOT_ANALYSIS}
                    <HeadingWithToolTip
                      heightIcon="18px"
                      heightIconXSm="17px"
                      toolTipText={TOOLTIP_SWOT}
                    />
                  </h1>
                )
              }
              {isMob ? (
                isSwotTab
                  ? (
                    <div className="responsive-update-switch">
                      {refreshSpecficCompany || swotLoading ? null : (
                        <UpdatedPill
                          date={createdAt}
                        />
                      )}
                      {swotLoading && companyProfileLoading ? null
                        : (
                          <ViewSwitcher
                            swotTab
                            tabCheck={fromNewsTab ? !viewAll : viewAll}
                            swotToggle={toggleSwotView}
                            disabledViewAction={false}
                          />
                        )}
                    </div>
                  ) : (
                    <div className="responsive-update-switch">
                      {refreshSpecficCompany || swotLoading ? null : (
                        <UpdatedPill
                          date={swotData?.createdAt}
                        />
                      )}
                      {swotLoading ? null
                        : (
                          <ViewSwitcher
                            tabCheck={fromNewsTab ? false : viewAll}
                            redirectUrl={`${COMPANY_SWOT_ROUTE}${companyId || ''}&fromNewsTab=true`}
                            disabledViewAction={false}
                          />
                        )}
                    </div>
                  )
              ) : null}
            </div>
          </div>
          <div className="right-side-div-swot">
            {!isMob && !refreshSpecficCompany && !swotLoading ? (isSwotTab
              ? (
                <UpdatedPill
                  date={createdAt}
                />
              ) : (
                <UpdatedPill
                  date={swotData?.createdAt}
                />
              )
            ) : null}
            {swotData?.refresh && !swotLoading
              ? (
                <CustomRefreshButton
                  onRefresh={handleRefresh}
                  buttonText={refreshSpecficCompany ? 'Refreshing' : 'Refresh'}
                  isCluster={isCluster}
                  clusterCompanyId={clusterCompanyId}
                />
              ) : null}
            {!isMob && !swotLoading ? (isSwotTab
              ? (
                <ViewSwitcher
                  swotTab
                  tabCheck={fromNewsTab ? !viewAll : viewAll}
                  swotToggle={toggleSwotView}
                  disabledViewAction={false}
                />
              ) : (
                <ViewSwitcher
                  tabCheck={fromNewsTab ? false : viewAll}
                  redirectUrl={`${COMPANY_SWOT_ROUTE}${companyId || ''}&fromNewsTab=true`}
                  disabledViewAction={false}
                />
              )
            ) : null}
          </div>
        </div>
      </div>
      <div className={classNames("swot-tab-area", { clusterLoader: isCluster })}>
        {swotLoading && isCluster ? (
          <div className="spinner">
            <Spin />
          </div>
        ) : (
          <SwotPillDesk
            isSwotTab={isSwotTab}
            viewLess={fromNewsTab ? viewAll : !viewAll}
            showRefreshPopup={refreshSpecficCompany}
            swotData={swotAnalysis}
            swotLoading={swotLoading}
          />
        )}
      </div>
    </Wrapper>
  );
};
SwotAnalysis.defaultProps = defaultProps;
export default SwotAnalysis;
